import { ExceptionStatus } from 'modules/contractedService/domain/ors/exception/ExceptionStatus'
import { OrsServiceExceptionRepository } from 'modules/contractedService/domain/ors/exception/repository/OrsServiceExceptionRepository'
import { useExceptionManagementTable } from 'pages/authorization/pending/exception/table/hooks/useExceptionManagementTable'
import { FC, useRef } from 'react'
import { Loading, Table, TableHandle, UfinetSectionBox } from 'ufinet-web-components'
import { useTranslator } from 'ufinet-web-functions'

type Props = {
	orsServiceExceptionRepository: OrsServiceExceptionRepository
	variant: ExceptionStatus
}

const ExceptionManagementTable: FC<Props> = ({ orsServiceExceptionRepository, variant }) => {
	const translate = useTranslator()
	const tableRef = useRef<TableHandle>(null)

	const { orsServiceExceptions, heading, table } = useExceptionManagementTable({
		orsServiceExceptionRepository,
		variant,
		tableRef,
		onClearFilters: () => tableRef.current?.clearFilter(),
	})

	return (
		<>
			{heading.visible && (
				<UfinetSectionBox className="mb-3">
					<h3>{heading.content}</h3>
				</UfinetSectionBox>
			)}
			<UfinetSectionBox className={table.loading ? 'form-disabled position-relative' : ''}>
				<Table
					ref={tableRef}
					cols={table.columns}
					content={orsServiceExceptions.all}
					emptyMessage={table.loading ? translate('LOADING_DOTS') : undefined}
					headerButtons={table.headerButtons}
					afterTablePFSEvent={table.onPFSEvent}
					onValuesDisplayedChange={table.onValuesDisplayedChange}
				/>
				{table.loading && <Loading />}
			</UfinetSectionBox>
		</>
	)
}
export { ExceptionManagementTable }
